import React from 'react';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { PainPointSection } from '../components/PainPointSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function HomePage() {
  return <div className="min-h-screen bg-light-gray flex flex-col font-body" data-id="element-249">
      <StickyTopBar data-id="element-250" />
      <RecentPurchaseToast data-id="element-251" />
      <main className="flex-grow pt-[40px] md:pt-[44px]" data-id="element-252">
        <HeroSection data-id="element-253" />
        <PainPointSection data-id="element-254" />
        <SolutionSection data-id="element-255" />
        <TestimonialsSection data-id="element-256" />
        <BonusSection data-id="element-257" />
        <PricingSection data-id="element-258" />
        <FinalCTASection data-id="element-259" />
      </main>
      <Footer data-id="element-260" />
    </div>;
}